export enum ShareTarget {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  LINK = 'link'
}
